import { apiWrapper } from '../helper/api-wrapper';

export const getListDisbursementVendor = async (payload) => {
  try {
    const response = await apiWrapper.get(
      `merchants/design/disbursement?type=${encodeURIComponent(
        payload?.type
      )}&query=${encodeURIComponent(
        payload?.query
      )}&startDate=${encodeURIComponent(
        payload?.date
      )}&endDate=${encodeURIComponent(
        payload?.dateEnd
      )}&sort=${encodeURIComponent(payload?.sort)}&offset=${encodeURIComponent(
        payload?.offset
      )}&limit=${encodeURIComponent(payload?.limit)}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getListDisbursementVendorReal = async (payload) => {
  try {
    const response = await apiWrapper.get(
      `merchants/design/disbursement/vendor?orderType=${encodeURIComponent(
        payload?.orderType
      )}&type=${encodeURIComponent(payload?.type)}&query=${encodeURIComponent(
        payload?.query
      )}&startDate=${encodeURIComponent(
        payload?.date
      )}&endDate=${encodeURIComponent(
        payload?.dateEnd
      )}&sort=${encodeURIComponent(payload?.sort)}&offset=${encodeURIComponent(
        payload?.offset
      )}&limit=${encodeURIComponent(payload?.limit)}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const requestDisbursementDesigner = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchant/design/request_disbursement`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const requestDisbursementVendor = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchant/design/request_disbursement/vendor`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getDetailDisbursement = async (id) => {
  try {
    const response = await apiWrapper.get(
      `merchants/design/disbursement/detail/${parseInt(id)}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};
